import { useEffect, useRef, useState } from "react";

const REDUCED = typeof window !== "undefined" && window.matchMedia &&
  window.matchMedia("(prefers-reduced-motion: reduce)").matches;

// Sisterhood+ cinematic splash — a faithful re-tone of the Brotherhood+ splash.
export default function SplashExperience({ onFinish }) {
  const [leaving, setLeaving] = useState(false);
  const done = useRef(false);
  useEffect(() => {
    const leaveAt = REDUCED ? 1400 : 4600;
    const total = REDUCED ? 1900 : 5200;
    const t1 = setTimeout(() => setLeaving(true), leaveAt);
    const t2 = setTimeout(() => { if (!done.current) { done.current = true; onFinish(); } }, total);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, [onFinish]);

  return (
    <div className={`sh-splash${leaving ? " sh-splash--leave" : ""}${REDUCED ? " sh-splash--reduced" : ""}`}
      role="img" aria-label="Sisterhood+" data-testid="web-splash">
      <style>{CSS}</style>
      <div className="sh-splash__wm" aria-hidden="true"><div className="sh-splash__drift">
        <span className="sh-splash__wmtext">S<span className="sh-splash__wmplus">+</span></span>
      </div></div>
      <div className="sh-splash__logo"><div className="sh-splash__breathe">
        <span className="sh-splash__word">
          <span className="sh-splash__wordtext">Sisterhood</span>
          <span className="sh-splash__wordglow" aria-hidden="true">Sisterhood</span>
          <span className="sh-splash__plus">+</span>
        </span>
        <span className="sh-splash__tagline">Made with us in mind</span>
      </div></div>
    </div>
  );
}

const CSS = `
.sh-splash{position:fixed;inset:0;z-index:9999;background:#291B2D;display:flex;flex-direction:column;align-items:center;justify-content:center;overflow:hidden;opacity:1;transition:opacity .56s cubic-bezier(.25,.1,.25,1);}
.sh-splash--leave{opacity:0;}
.sh-splash__wm{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;z-index:0;pointer-events:none;user-select:none;}
.sh-splash__drift{animation:shDrift 11s ease-in-out infinite alternate;}
.sh-splash__wmtext{display:block;font-family:'Outfit',sans-serif;font-weight:800;font-size:clamp(300px,42vw,620px);line-height:1;letter-spacing:-.04em;color:#fff;opacity:0;animation:shWm 1.6s cubic-bezier(.25,.1,.25,1) .2s both;}
.sh-splash__wmplus{color:#C89B55;}
.sh-splash__logo{position:relative;z-index:1;animation:shFade 1.2s cubic-bezier(.25,.1,.25,1) both;transition:transform .7s cubic-bezier(.25,.1,.25,1);}
.sh-splash--leave .sh-splash__logo{transform:translateY(-12%) scale(1);}
.sh-splash__breathe{display:flex;flex-direction:column;align-items:center;}
.sh-splash__word{position:relative;color:#fff;font-family:'Outfit',sans-serif;font-weight:700;font-size:46px;letter-spacing:-.5px;line-height:1;}
.sh-splash__wordtext{color:#FCFAF6;}
.sh-splash__wordglow{position:absolute;top:0;left:0;color:#FFEBB8;text-shadow:0 0 14px rgba(255,236,190,.85);pointer-events:none;-webkit-mask-image:linear-gradient(90deg,transparent 0%,#000 42%,#000 58%,transparent 100%);mask-image:linear-gradient(90deg,transparent 0%,#000 42%,#000 58%,transparent 100%);-webkit-mask-size:55% 100%;mask-size:55% 100%;-webkit-mask-repeat:no-repeat;mask-repeat:no-repeat;-webkit-mask-position:-120% 0;mask-position:-120% 0;animation:shGlow 1.3s linear 1.4s 1 both;}
.sh-splash__plus{display:inline-block;color:#C89B55;opacity:.12;animation:shPlus 1s cubic-bezier(.25,.1,.25,1) 2.4s 1 both;}
.sh-splash__tagline{margin-top:14px;color:rgba(252,250,246,.55);font-family:'Outfit',sans-serif;font-size:13px;letter-spacing:2.5px;text-transform:uppercase;font-weight:600;animation:shTag 1s cubic-bezier(.25,.1,.25,1) .5s both;}
@keyframes shWm{0%{opacity:0;transform:scale(1.08);}100%{opacity:.06;transform:scale(1);}}
@keyframes shDrift{0%{transform:translate(-20px,-12px);}100%{transform:translate(20px,12px);}}
@keyframes shFade{0%{opacity:0;transform:scale(.98);}100%{opacity:1;transform:scale(1);}}
@keyframes shGlow{0%{-webkit-mask-position:-120% 0;mask-position:-120% 0;}100%{-webkit-mask-position:210% 0;mask-position:210% 0;}}
@keyframes shPlus{0%{opacity:.12;transform:scale(.9);}28%{opacity:1;color:#FFF2D4;text-shadow:0 0 26px rgba(255,236,190,.95);transform:scale(1.3);}100%{opacity:1;color:#C89B55;transform:scale(1);}}
@keyframes shTag{0%{opacity:0;transform:translateY(10px);}100%{opacity:1;transform:translateY(0);}}
.sh-splash--reduced .sh-splash__wordglow,.sh-splash--reduced .sh-splash__drift{animation:none;}
.sh-splash--reduced .sh-splash__plus{opacity:1;animation:none;}
@media (prefers-reduced-motion:reduce){.sh-splash__wordglow,.sh-splash__drift{animation:none;}.sh-splash__plus{opacity:1;animation:none;}}
`;
